<template>
  <div class="d-flex justify-center">
    <img
      alt="Logo"
      :src="logo"
      v-bind="$attrs"
      style="aspect-ratio: 2/1; cursor: pointer; max-width: 100%"
      transition="scale-transition"
    >
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import Logo from "@/assets/logo.svg";
import { useProducersStore } from "@/stores/producers";

defineOptions({
  name: "MainLogo",
});

const producersStore = useProducersStore();

const logo = computed(() => {
  const producer = producersStore.selected;

  if (producer.id.includes("0")) {
    return Logo;
  }

  const id = producer.id[0];

  return `https://storage.torcedordevantagens.com.br/ticket/${id}/logo.svg`;
});
</script>
